import * as React from 'react';
import { useUIFacade } from '../../../../../../../ui/facades/ui.facade';
import DateTemplate from '../../../../../../../ui/templates/columns/DateTemplate';
import LinkTemplate from '../../../../../../../ui/templates/columns/LinkTemplate';
import ValueTemplate from '../../../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../../../ui/widgets/custom/PrwcDataTableAdvanced';

const GroupList = (props: any) => {

  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteGroup);
  }

  const deleteGroup = (rowData: any) => {
    console.log('delete group --');
    console.log(rowData);
  }

  const editGroup = (rowData: any) => {
    console.log('edit group ---');
    console.log(rowData);
    onEdit(rowData);
  }

  const data = [
    {
      id: 1000,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1001,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1002,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1003,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1004,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1005,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1006,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1007,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1008,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1009,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1010,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1011,
      name: "Group_One",
      abbreviation: "GND",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    }
  ];

  const dataTable = {
    columns: [
      {
        field: "id",
        headerLabelKey: "userCategories.label.groupId",
        bodyTemplate: LinkTemplate,
        className: "w-10 text-xs",
        sortable: true,
        command: (rowData: any) => {
          editGroup(rowData);
        }
      },
      {
        field: "name",
        headerLabelKey: "userCategories.label.groupName",
        bodyTemplate: ValueTemplate,
        className: "w-20 text-xs",
        sortable: true
      },
      {
        field: "abbreviation",
        headerLabelKey: "userCategories.label.abbreviation",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "lastUpdated",
        headerLabelKey: "userCategories.label.lastUpdated",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "description",
        headerLabelKey: "userCategories.label.description",
        bodyTemplate: ValueTemplate,
        className: "w-32 text-xs",
        sortable: true
      }
    ],
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editGroup}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default GroupList;
